import { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { DefaultTheme, useTheme } from 'styled-components';
import { useHistory, useLocation } from 'react-router-dom';
import { FiEdit3, FiTrash } from 'react-icons/fi';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import { Formik, Form, FormikHelpers } from 'formik';
import { MdSearch } from 'react-icons/md';
import { Breadcrumb } from '../../components/Breadcrumb';
import { Button } from '../../components/Button';
import { Table } from '../../styles/components';
import api from '../../services/api';
import { IUser } from '../../interfaces/IUser';
import { Input } from '../../components/Input';
import { Filters } from '../../components/Filters';
import { IPagination, Pagination } from '../../components/Pagination';

interface SubmitProps {
  name: string;
}

export const Users = () => {
  const location = useLocation();
  const history = useHistory();
  const theme: DefaultTheme = useTheme();
  const [users, setUsers] = useState<IUser[]>([]);
  const [pagination, setPagination] = useState<IPagination>();

  useEffect(() => {
    api
      .get(`/users/${location.search}`)
      .then(({ data }) => {
        setUsers(data.data);
        setPagination({
          currentPage: data.meta.current_page,
          perPage: data.meta.per_page,
          total: data.meta.total,
        });
      })
      .catch(() => toast.error('Erro ao buscar usuários'));
  }, [location.search]);

  const handleRemoveUser = (idUser: number) => {
    Swal.fire({
      title: `<h4 style="color: ${theme.colors.textSecondary}">Você tem certeza?</h4>`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: theme.colors.secondary,
      cancelButtonColor: theme.colors.textSecondary,
      cancelButtonText: 'Fechar',
      confirmButtonText: 'Sim, apagar!',
    }).then(async result => {
      if (result.isConfirmed) {
        try {
          await api.delete(`users/${idUser}`);
          setUsers(old => [...old.filter(item => item.id !== idUser)]);
          toast.success('Usuário excluído com sucesso');
        } catch {
          toast.error('Erro ao excluir usuário');
        }
      }
    });
  };

  const handleSubmit = (
    values: SubmitProps,
    helpers?: FormikHelpers<SubmitProps>,
  ) => {
    const { name } = values;
    const urlSearchParams = new URLSearchParams(window.location.search);
    urlSearchParams.set('name', name);
    urlSearchParams.delete('page');

    history.push({
      pathname: history.location.pathname,
      search: urlSearchParams.toString(),
    });

    if (helpers) {
      helpers.setFieldValue('name', '');
    }
  };

  return (
    <div>
      <Breadcrumb
        items={[
          {
            title: 'Usuários',
          },
        ]}
      />
      <Row className="d-flex align-items-center mt-4">
        <Col md={10} xs={9}>
          <h4>Gerenciar usuários</h4>
        </Col>
        <Col md={2} xs={{ span: 3 }}>
          <Button
            type="button"
            background={theme.colors.secondary}
            color="#fff"
            onClick={() => history.push('/users/new')}
          >
            Novo
          </Button>
        </Col>
      </Row>

      <Formik
        initialValues={{
          name: '',
        }}
        enableReinitialize
        onSubmit={(values, helpers) => handleSubmit(values, helpers)}
      >
        <Form>
          <Row>
            <Col md={10} xs={8}>
              <Input
                type="text"
                name="name"
                icon={MdSearch}
                placeholder="Nome do usuário"
              />
            </Col>
            <Col md={2} xs={4}>
              <Button
                type="submit"
                style={{ marginTop: '1rem' }}
                background={theme.colors.secondary}
                color="#fff"
              >
                Buscar
              </Button>
            </Col>
          </Row>
          <Filters />
        </Form>
      </Formik>

      <Row className="mt-4">
        <Col>
          <Table responsive>
            <thead>
              <tr>
                <th>Nome</th>
                <th>Telefone</th>
                <th>Opções</th>
              </tr>
            </thead>
            <tbody>
              {users.map(user => (
                <tr key={user.id}>
                  <td>
                    <h6>{user.name}</h6>
                  </td>
                  <td>
                    <span>(92) 98410-8965</span>
                  </td>
                  <td>
                    <div>
                      <button
                        type="button"
                        onClick={() => handleRemoveUser(user.id)}
                      >
                        <FiTrash />
                      </button>
                      <button
                        type="button"
                        onClick={() => history.push(`/users/${user.id}`)}
                      >
                        <FiEdit3 />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          {pagination && <Pagination {...pagination} />}
        </Col>
      </Row>
    </div>
  );
};
